import React, { useEffect } from 'react';
import { resetSortOrder, setSortOrder } from '../../redux/slices/productSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectSortOrder } from '../../redux/selectors/productSelector';

const ProductSortSelect = () => {
  const sortOrder = useSelector(selectSortOrder);
  const dispatch = useDispatch();

  // Reset sort order to default when this component mounts
  useEffect(() => {
    dispatch(resetSortOrder());
  }, [dispatch]);

  // Dispatch the action to display product with selected sort value
  const handleSortChange = (e) => {
    dispatch(setSortOrder(e.target.value));
  };

  return (
    <select
      className="custom-select"
      onChange={handleSortChange}
      value={sortOrder}
    >
      <option value="default">Default sorting</option>
      <option value="low-to-high">Low to High</option>
      <option value="high-to-low">High to Low</option>
      <option value="new-added">New Added</option>
      <option value="on-sale">On Sale</option>
    </select>
  );
};

export default ProductSortSelect;
